module.exports = __webpack_public_path__ + "static/img/sm_js_3.46532bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_3.png
// module id = KtBv
// module chunks = 1